<template>
  <b-form @submit.prevent="save">
    <b-form-group label="Name:">
      <b-form-input
        type="text"
        name="title"
        v-model.trim="$v.displayName.$model"
        :class="{ 'is-invalid': $v.displayName.$error }"
        autocomplete="off"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.displayName.required">
        Display Name is required
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.displayName.isUnique">
        Column with the same name already exists
      </b-form-invalid-feedback>
    </b-form-group>
    <b-button
      variant="success"
      type="submit"
      >
      Save
    </b-button>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'

export default {
  props: [
    'type',
    'gridId',
    'rowIndex',
    'sectionIndex'
  ],
  data () {
    return {
      inPorcess: false,
      displayName: null
    }
  },
  methods: {
    async save () {
      if (this.inPorcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inPorcess = true

      const data = {
        type: this.type,
        gridId: this.gridId,
        displayName: this.displayName,
        propertyName: this.$sanitize(this.displayName)
      }
      console.log('RegularForm.vue', data, this.rowIndex, this.sectionIndex)

      await db.dataGrid.data.addColumn(data, this.rowIndex, this.sectionIndex)

      this.$store.commit('dataGrid_setLogsValue', {
        type: 'ColChange',
        newVal: data.displayName,
        gridId: data.gridId,
      })
      this.inPorcess = false
      this.displayName = null
      this.$nextTick(() => {
        this.$v.$reset()
      })

      this.$emit('submitted')
    },
  },
  validations: {
    displayName: {
      required,
      isUnique (value) {
        if (!this.displayName) return true
        const tData = this.$parent.gridData
        if (!tData) return true
        const firstRow = tData[Object.keys(this.$parent.gridData)[0]]
        const keys = Object.keys(firstRow)

        return (!(~keys.indexOf(utils.sanitize(value))))
      }
    }
  }
}
</script>
